import React, { useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, resolveImg, formatApiError } from "@/lib/api";

export default function AdminField({ field, value, onChange }) {
  const { key, label, type = "text" } = field;
  const [uploading, setUploading] = useState(false);
  const base = "w-full bg-av-black border border-white/15 rounded-lg px-3 py-2.5 text-sm text-av-white focus:border-av-lime outline-none";

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Immagine caricata");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Upload fallito");
    } finally { setUploading(false); }
  };

  if (type === "textarea")
    return (
      <div><Lbl label={label} /><textarea data-testid={`admin-field-${key}`} rows={4} value={value || ""} onChange={(e) => onChange(e.target.value)} className={`${base} resize-y`} /></div>
    );

  if (type === "bool")
    return (
      <label className="flex items-center gap-3 cursor-pointer py-1">
        <input data-testid={`admin-field-${key}`} type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} className="w-4 h-4 accent-[#2ea33f]" />
        <span className="text-sm text-av-white/85">{label}</span>
      </label>
    );

  if (type === "number")
    return (<div><Lbl label={label} /><input data-testid={`admin-field-${key}`} type="number" value={value ?? 0} onChange={(e) => onChange(Number(e.target.value))} className={base} /></div>);

  if (type === "list") {
    const arr = Array.isArray(value) ? value : [];
    return (
      <div>
        <Lbl label={`${label} (una voce per riga)`} />
        <textarea data-testid={`admin-field-${key}`} rows={4} value={arr.join("\n")} onChange={(e) => onChange(e.target.value.split("\n").map((s) => s.trim()).filter(Boolean))} className={`${base} resize-y`} />
      </div>
    );
  }

  if (type === "image")
    return (
      <div>
        <Lbl label={label} />
        {value && (
          <div className="relative mb-2 inline-block">
            <img src={resolveImg(value)} alt="" className="h-24 rounded-lg object-cover border border-white/15" />
            <button type="button" onClick={() => onChange("")} className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-red-500 text-white flex items-center justify-center"><X size={13} /></button>
          </div>
        )}
        <div className="flex flex-col sm:flex-row gap-2">
          <input data-testid={`admin-field-${key}`} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="URL immagine" className={base} />
          <label className="shrink-0 inline-flex items-center justify-center gap-2 rounded-lg border border-white/20 px-4 py-2.5 text-sm text-av-white cursor-pointer hover:border-av-lime">
            {uploading ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />} Carica
            <input type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files[0])} />
          </label>
        </div>
      </div>
    );

  return (<div><Lbl label={label} /><input data-testid={`admin-field-${key}`} value={value || ""} onChange={(e) => onChange(e.target.value)} className={base} /></div>);
}

const Lbl = ({ label }) => <label className="block text-xs font-medium text-av-gray mb-1.5">{label}</label>;
